export const ID = '845a4c55-0d0a-4d1f-932f-ce3adaaa9843';

export const NAME = 'Amenities: Facility';
